module.exports = require("buffer");


//////////////////
// WEBPACK FOOTER
// external "buffer"
// module id = 327
// module chunks = 0